// @flow

import type { AlertsState } from "./types";

export const initialState: AlertsState = {
  requestsInProgress: 0,
  schema: null,
  list: null,
  error: null,
  current: null,
  draft: null,
  assignments: [],
  draftAssignments: [],
  modals: {
    showAddAlertRecipientModal: false,
    showAddAlertAttachmentModal: false,
    showDeleteAlertAttachmentModal: false,
  },
};

export default initialState;
